import { getEditLocation } from "../../../core/util/functions";

export const cashBalanceListLocation = "/reports/cashbalance";
//export const getBankEditLocation = (id?: string) => getEditLocation(cashBalanceListLocation, undefined, id);

//export const editRouter = getBankEditLocation(":bankId?");
